import React from 'react';
import PropTypes from 'prop-types';
import MaterialCircularProgress from '@material-ui/core/CircularProgress';

const CircularProgress = ({ color, size, classes }) => {
  return (
    <MaterialCircularProgress color={color} size={size} classes={classes} />
  );
};

CircularProgress.propTypes = {
  color: PropTypes.oneOf(['primary', 'secondary', 'inherit']),
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

CircularProgress.defaultProps = {
  color: 'primary',
  size: 40,
};

export default CircularProgress;
